"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAdsFetch = exports.googleAdsFetchResultSchema = exports.googleAdsFetchArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var googleAdsFetchInputSchema = zod_1.z
    .object({
    domain: zod_1.z
        .string()
        .nullish()
        .describe('The domain to search for ads. e.g. google.com, zapier.com, etc. Alternatively, advertiser_id can be specified.'),
    advertiser_id: zod_1.z
        .string()
        .nullish()
        .describe('The Google Advertiser ID to search for ads. Alternatively, domain can be specified.'),
    region: zod_1.z
        .string()
        .nullish()
        .describe('The region to search for ads. e.g. US, UK, etc. Optional.'),
    start_date: zod_1.z
        .string()
        .nullish()
        .describe('Start date for ad search in YYYY-MM-DD format. e.g. 2025-08-11. Optional.'),
    end_date: zod_1.z
        .string()
        .nullish()
        .describe('End date for ad search in YYYY-MM-DD format. e.g. 2025-08-11. Optional.'),
    maxItems: zod_1.z
        .number()
        .describe('The maximum number of ads to fetch. Unless specified, defaults to 10.')
        .default(10),
    options: zod_1.z
        .object({
        failIfEmpty: zod_1.z
            .boolean()
            .default(true)
            .describe('Fail if the search returns no results. Unless specified, defaults to true.'),
    })
        .describe('Search options'),
    emitMode: common_1.emitModeSchema,
})
    .describe("Either domain or advertiser_id must be specified in order to perform a fetch.");
exports.googleAdsFetchArgsSchema = googleAdsFetchInputSchema;
var googleAdsFetchResponseSchema = zod_1.z.array(zod_1.z.object({
    advertiserId: zod_1.z.string(),
    creativeId: zod_1.z.string(),
    lastShown: zod_1.z.string().nullish(),
    firstShown: zod_1.z.string().nullish(),
    format: zod_1.z.string(),
    overallImpressions: zod_1.z.object({
        min: zod_1.z.string().nullish(),
        max: zod_1.z.string().nullish(),
    }),
    creativeRegions: zod_1.z
        .array(zod_1.z.object({
        regionCode: zod_1.z.string().nullish(),
        regionName: zod_1.z.string().nullish(),
    }))
        .nullish(),
    regionStats: zod_1.z.array(zod_1.z.object({
        regionCode: zod_1.z.string().nullish(),
        regionName: zod_1.z.string().nullish(),
        firstShown: zod_1.z.string().nullish(),
        lastShown: zod_1.z.string().nullish(),
        impressions: zod_1.z.record(zod_1.z.any()).nullish().describe('Impression data by platform'),
        platformImpressions: zod_1.z.array(zod_1.z.any()).nullish().describe('Platform-specific impressions'),
    })),
    variations: zod_1.z.array(zod_1.z.object({
        // Common fields
        destinationUrl: zod_1.z.string().nullish(),
        headline: zod_1.z.string().nullish(),
        description: zod_1.z.string().nullish(),
        // Image format fields
        image: zod_1.z.string().nullish().describe('Image URL for image-based ads'),
        images: zod_1.z.array(zod_1.z.string()).nullish().describe('Multiple image URLs'),
        // Video format fields
        videoId: zod_1.z.string().nullish().describe('YouTube video ID'),
        youtubeUrl: zod_1.z.string().nullish().describe('Full YouTube URL'),
        visibleUrl: zod_1.z.string().nullish().describe('Visible destination URL'),
        callToAction: zod_1.z.string().nullish().describe('Call to action text'),
        // Text format fields
        allText: zod_1.z.string().nullish().describe('Full ad text for text ads'),
        imageUrl: zod_1.z.string().nullish().describe('Image URL for text ads'),
    })),
}));
exports.googleAdsFetchResultSchema = googleAdsFetchResponseSchema;
exports.googleAdsFetch = (0, common_1.createEmitModeToolMetadata)({
    id: 'googleAdsFetch',
    displayName: 'Google Ads Fetch',
    displayDescription: 'Fetch Google ads using the Google Ads Library API.',
    category: 'ads',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'google_ads',
    argsSchema: exports.googleAdsFetchArgsSchema,
}, googleAdsFetchResponseSchema);
